export default {
  SET_BANNED_WORKER_LIST_DATA: "workers/SET_BANNED_WORKER_LIST_DATA",
  UPDATE_BANNED_WORKER_PAGE_SORT: "workers/UPDATE_BANNED_WORKER_PAGE_SORT",
  UPDATE_BANNED_WORKER_PAGE_FILTER: "workers/UPDATE_BANNED_WORKER_PAGE_FILTER",
  SET_PREFERRED_WORKER_LIST_DATA: "workers/SET_PREFERRED_WORKER_LIST_DATA",
  UPDATE_PREFERRED_WORKER_PAGE_SORT: "workers/UPDATE_PREFERRED_WORKER_PAGE_SORT",
  UPDATE_PREFERRED_WORKER_PAGE_FILTER: "workers/UPDATE_PREFERRED_WORKER_PAGE_FILTER",
};
